var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-citation"},[_c('Citation',{attrs:{"type":_vm.certType},on:{"authComplete":_vm.authComplete}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"footer-text"},[_vm._v(" 코리아크레딧뷰로에서 인증 받은 본인인증을 사용하고 있습니다. "),_c('span',[_vm._v("본인인증 실패시 코리아크레딧뷰로 고객센터 02-708-100로 문의하세요")])])
}]

export { render, staticRenderFns }